import { create } from 'zustand';

interface FormData {
  pickup: string;
  dropoff: string;
  date: string;
  time: string;
  pickupPlaceId: string;
  dropoffPlaceId: string;
}

interface ModalState {
  isBookingModalOpen: boolean;
  formData: FormData;
  openBookingModal: (data?: FormData) => void;
  closeBookingModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  isBookingModalOpen: false,
  formData: {
    pickup: '',
    dropoff: '',
    date: '',
    time: '',
    pickupPlaceId: '',
    dropoffPlaceId: ''
  },
  openBookingModal: (data) => set((state) => ({ 
    isBookingModalOpen: true,
    formData: data ? data : state.formData
  })),
  closeBookingModal: () => set({ isBookingModalOpen: false })
}));
